import AlarmBell from "./AlarmBell";
import ArrowBack from "./ArrowBack";
import ArrowDown from "./ArrowDown";
import ArrowForward from "./ArrowForward";
import ArrowUp from "./ArrowUp";
import BuildingBusinessOffice from "./BuildingBusinessOffice";
import Bullets from "./Bullets";
import CircleActionsAlertInfo from "./CircleActionsAlertInfo";
import CircleActionsAlertQuestion from "./CircleActionsAlertQuestion";
import CircleActionsClose from "./CircleActionsClose";
import CircleActionsSuccess from "./CircleActionsSuccess";
import CircleBack from "./CircleBack";
import CircleForward from "./CircleForward";
import CircleMinus from "./CircleMinus";
import CirclePlus from "./CirclePlus";
import Component from "./Component";
import Configure from "./Configure";
import Copy from "./Copy";
import Database from "./Database";
import Delete from "./Delete";
import Download from "./Download";
import Drag from "./Drag";
import Edit from "./Edit";
import File from "./File";
import Folder from "./Folder";
import Guard from "./Guard";
import Hide from "./Hide";
import Home from "./Home";
import Image from "./Image";
import Key from "./Key";
import Location from "./Location";
import LogoutCircle from "./LogoutCircle";
import Mail from "./Mail";
import MenuGrid from "./MenuGrid";
import MenuHamburger from "./MenuHamburger";
import MenuVertical from "./MenuVertical";
import PeopleThree from "./PeopleThree";
import PeopleTwo from "./PeopleTwo";
import Profile from "./Profile";
import Projects from "./Projects";
import PlanetEarth from "./PlanetEarth";
import Refresh from "./Refresh";
import Settings from "./Settings";
import Search from "./Search";
import SortAlphabet from "./SortAlphabet";
import Time from "./Time";
import Truck from "./Truck";
import Upload from "./Upload";
import View from "./View";
import WorldGlobe from "./WorldGlobe";
import WorldNet from "./WorldNet";
import ActionPlus from "./ActionPlus";
import ActionMinus from "./ActionMinus";

const icons = {
  ActionPlus,
  ActionMinus,
  AlarmBell,
  ArrowBack,
  ArrowDown,
  ArrowForward,
  ArrowUp,
  BuildingBusinessOffice,
  Bullets,
  CircleActionsAlertInfo,
  CircleActionsAlertQuestion,
  CircleActionsClose,
  CircleActionsSuccess,
  CircleBack,
  CircleForward,
  CircleMinus,
  CirclePlus,
  Component,
  Configure,
  Copy,
  Database,
  Delete,
  Download,
  Drag,
  Edit,
  File,
  Folder,
  Guard,
  Hide,
  Home,
  Image,
  Key,
  Location,
  LogoutCircle,
  Mail,
  MenuGrid,
  MenuHamburger,
  MenuVertical,
  PeopleThree,
  PeopleTwo,
  PlanetEarth,
  Profile,
  Projects,
  Refresh,
  Settings,
  Search,
  SortAlphabet,
  Time,
  Truck,
  Upload,
  View,
  WorldGlobe,
  WorldNet,
};

export default icons;
